import NBAConfig from "./NBAConfig";
import NCAABConfig from "./NCAABConfig";
// import WCConfig from "./WCConfig";
import NHLConfig from "./NHLConfig";
import MLBConfig from "./MLBConfig";
import NFLConfig from "./NFLConfig";
import NCAAFConfig from "./NCAAFConfig";
import XFLConfig from "./XFLConfig";

import EPLConfig from "./EPLConfig";
import DEBConfig from "./DEBConfig";
import MLSConfig from "./MLSConfig";
import ESPConfig from "./ESPConfig";
import ITSAConfig from "./ITSAConfig";
import UCLConfig from "./UCLConfig";

import ATPConfig from "./ATPConfig";
import WTAConfig from "./WTAConfig";
import GOLFConfig from "./GOLFConfig";
import EUROS2024Config from "./euros2024Config";

export { default as PICK_TYPES } from "./PickTypes";

export interface BetQLPickType {
  name: string;
  shortName: string;
  abbrev: string;
  key: string;
  linePeriod: string;
  linePeriodKey: string;
  filterKey: string;
  awayDisplay: string;
  homeDisplay: string;
  drawDisplay?: string;
  awayKey: string;
  homeKey: string;
  drawKey?: string;
  awayPriceKey: string;
  homePriceKey: string;
  drawPriceKey?: string;
  favoriteIndex: number;
}

export interface BetQLPickTypes {
  [key: string]: BetQLPickType;
  spread: BetQLPickType;
  moneyline: BetQLPickType;
  total: BetQLPickType;
  "1Hspread": BetQLPickType;
  "1Hmoneyline": BetQLPickType;
  "2Hspread": BetQLPickType;
  "2Hmoneyline": BetQLPickType;
  F5spread: BetQLPickType;
  F5moneyline: BetQLPickType;
  S5spread: BetQLPickType;
  S5moneyline: BetQLPickType;
  "1Pmoneyline": BetQLPickType;
  "1Pspread": BetQLPickType;
  "2Pmoneyline": BetQLPickType;
  "2Pspread": BetQLPickType;
  "3Pmoneyline": BetQLPickType;
  "3Pspread": BetQLPickType;
}

export interface NameKeyPair {
  name: string;
  key: string;
  url: string;
}

export interface BetQLSportItem {
  [key: string]: any;
  name: string; // Display Name
  url: string;
  tabName: string;
  icon: string;
  imagePath: string;
  key: string; // For use to query the APIs
  lookupKey: string; // string matching lookup key
  favoriteLine: string;
  isSoccer?: boolean;
  hasTeamPowerProjectionGrades: boolean;
  hasFGspreadPowerRating: boolean;
  hasFGmoneylinePowerRating: boolean;
  hasFGtotalPowerRating: boolean;
  has1HspreadPowerRating: boolean;
  has1HmoneylinePowerRating: boolean;
  has1HtotalPowerRating: boolean;
  has1PspreadPowerRating: boolean;
  has1PmoneylinePowerRating: boolean;
  has1PtotalPowerRating: boolean;
  hasPitchers: boolean;
  hasGoals: boolean;
  hasInjuries: boolean;
  hasNews: boolean;
  hasLineup: boolean;
  hasSchedule: boolean;
  hasConfiguredSchedule: boolean;
  hasTeamSummary: boolean;
  hasGameFilters: boolean;
  hasStadium: boolean;
  hasLocation: boolean;
  hasTeamRecord: boolean;
  hasApRank: boolean;
  hasConferenceDropdown: boolean;
  hasNewsInjuriesColumn: boolean;
  hasDraws: boolean;
  hasSharpData: boolean;
  hasTopTrendsData: boolean;
  hasPlayerProps: boolean;
  hasRecommendedBets: boolean;
  hasPopularEvents: boolean;
  isCollege: boolean;
  publicThreshold: number;
  sharpPercentThreshold: number;
  sharpCountThreshold: number;
  publicCountThreshold: number;
  defaultUserSetting: string;
  defaultColumnOrder: number[];
  filters: NameKeyPair[];
  periods: string[];
  periodKeys: string[];
  pickTypes: string[];
  conferenceList?: NameKeyPair[];
  trendTypes: NameKeyPair[];
}

export interface BetQLSportList {
  [key: string]: BetQLSportItem;
  ncaaf: BetQLSportItem;
  nfl: BetQLSportItem;
  nba: BetQLSportItem;
  ncaab: BetQLSportItem;
  mlb: BetQLSportItem;
  nhl: BetQLSportItem;
  xfl: BetQLSportItem;
  epl: BetQLSportItem;
  deb: BetQLSportItem;
  mls: BetQLSportItem;
  esp: BetQLSportItem;
  itsa: BetQLSportItem;
  ucl: BetQLSportItem;
  atp: BetQLSportItem;
  wta: BetQLSportItem;
  golf: BetQLSportItem;
  // wc: BetQLSportItem;
}

export const SPORTS_LIST: BetQLSportList = {
  nba: NBAConfig,
  ncaab: NCAABConfig,
  xfl: XFLConfig,
  nhl: NHLConfig,
  mlb: MLBConfig,
  nfl: NFLConfig,
  ncaaf: NCAAFConfig,
  epl: EPLConfig,
  deb: DEBConfig,
  mls: MLSConfig,
  esp: ESPConfig,
  itsa: ITSAConfig,
  ucl: UCLConfig,
  atp: ATPConfig,
  wta: WTAConfig,
  golf: GOLFConfig,
  // wc: WCConfig,
  euros2024: EUROS2024Config,
};

// Consensus
export const DEFAULT_BOOK_ID: string = "2a09f6df-5b47-4f87-82ef-91a77d26eef9";
// Pinnacle
export const DEFAULT_SOCCER_BOOK_ID: string = "f3a8127f-937f-475d-a97f-4e8cada75aad";
export const SPORTS_NAME_LIST: string[] = Object.keys(SPORTS_LIST);
export const DEFAULT_SPORT_NAME = "nba";
export const DEFAULT_SPORT: BetQLSportItem = {
  ...SPORTS_LIST[DEFAULT_SPORT_NAME],
};
